module.exports = __webpack_public_path__ + "static/media/ridelightpro-logo.6493caf8.jpg";